const locales = {
  fr: {
    lodgings: "Hébergements",
    "ski-passes": "Forfaits de ski",
    "arrival-label": "Date d'arrivée",
    "arrival-placeholder": "Arrivée le...",
    "departure-label": "Date de départ",
    "departure-placeholder": "Départ le...",
    "pax-plan-label": "Nombre de personne",
    "pax-plan-placeholder": "Nous sommes...",
    "pax-plan-adult": "adulte",
    "pax-plan-adults": "adultes",
    "pax-plan-child": "enfant",
    "pax-plan-children": "enfants",
    search: "Rechercher",
    book: "Réserver",
    "first-day-label": "1er jour skié",
    "first-day-placeholder": "Selectionnez une date",
    adults: "Adultes",
    "adults-helper": "18 ans et plus",
    children: "Enfants",
    "children-helper": "De 0 à 17 ans",
    age: "Âge des enfants au jour de votre arrivé",
    child: "Enfant",
    year: "an",
    years: "ans",
    confirm: "Confirmer",
    "book-ski-passes": "<b>Réservez vos forfaits</b> en toute simplicité",
    "book-ski-passes-button": "Je réserve mes forfaits",
    "no-stay": "Découvrez toute l'offre de l'Alpe d'Huez",
  },
  en: {
    lodgings: "Accommodation",
    "ski-passes": "Ski passes",
    "arrival-label": "Arrival date",
    "arrival-placeholder": "I'm coming on...",
    "departure-label": "Departure",
    "departure-placeholder": "I'm leaving on...",
    "pax-plan-label": "Group",
    "pax-plan-placeholder": "We are...",
    "pax-plan-adult": "adult",
    "pax-plan-adults": "adults",
    "pax-plan-child": "child",
    "pax-plan-children": "children",
    search: "Search",
    book: "Book",
    "first-day-label": "1st day of ski",
    "first-day-placeholder": "Pick a date",
    adults: "Adults",
    "adults-helper": "18 and older",
    children: "Children",
    "children-helper": "From 0 to 17 years old",
    age: "Children ages on the day of arrival",
    child: "Child",
    year: "year",
    years: "years",
    confirm: "Confirm",
    "book-ski-passes": "<b>Book your ski passes</b> with ease on our website",
    "book-ski-passes-button": "I book my ski passes!",
    "no-stay": "Discover all the offer of Alpe d'Huez",
  },
};

export default locales;
